// extracted by mini-css-extract-plugin
export var card = "personal-training-item-card-module--card--813e1";
export var iconWrapper = "personal-training-item-card-module--icon-wrapper--98ccc";
export var img = "personal-training-item-card-module--img--5b2f9";
export var imgWrapper = "personal-training-item-card-module--img-wrapper--24bbe";
export var label = "personal-training-item-card-module--label--b7d63";
export var ratioClass = "personal-training-item-card-module--ratio-class--f40a9";
export var title = "personal-training-item-card-module--title--61d40";